import { trackEvent } from '../../_common/client/tracking';
import { BaseComponent } from '../../base-component';
import { DIMENSION_SELECTED_IN_SHEET_TOPIC, DIMENSION_SELECTED_TOPIC, INVALID_DIMENSIONS_IN_SHEET_CONTENT_TOPIC } from '../../constants';
import { DimensionsStateEvent } from '../../dimension-selection-sheet-content/shared-types';

type DimTypeAndValue = { type: string; value: string };

export class DimensionSelectionSheetComponent extends BaseComponent {
    public rootSelector = '.js_pdp_dimension-selection-sheet';

    private lastPublishedDimensionStateEvent: DimensionsStateEvent | undefined;
    private selectedDimTypesAndValues: Array<DimTypeAndValue> = [];

    public async init(): Promise<void> {
        if (!this.isPresent()) return;
        this.storeLastPublishedDimensionStateEvent();
        this.disableSelectButtonIfDimensionsAreInvalid();
    }

    public async onHtmlLoaded(): Promise<void> {
        if (!this.isPresent()) return;
        this.addClickListenerForAdjustDimButton();
        this.addClickListenerForSelectButton();
        this.initializeSelectedDimTypesAndValues();
        this.setOverflowHiddenSheet();
    }

    private initializeSelectedDimTypesAndValues() {
        this.selectedDimTypesAndValues = [];

        this.getRootElement()
            .querySelectorAll('[data-dim-type]')
            .forEach(dimTypeNode => {
                const dimType = dimTypeNode.getAttribute('data-dim-type');
                const dimValue = dimTypeNode.querySelector('.js_pdp_dimension-selection-sheet__label-value')?.textContent?.trim();
                if (dimType && dimValue) {
                    this.selectedDimTypesAndValues.push({ type: dimType, value: dimValue });
                }
            });
    }

    private storeLastPublishedDimensionStateEvent() {
        o_global.eventQBus.on(DIMENSION_SELECTED_IN_SHEET_TOPIC, (dimensionsStateEvent: DimensionsStateEvent) => {
            this.lastPublishedDimensionStateEvent = dimensionsStateEvent;
        });
    }

    private disableSelectButtonIfDimensionsAreInvalid() {
        o_global.eventQBus.on(INVALID_DIMENSIONS_IN_SHEET_CONTENT_TOPIC, ({ hasInvalidDimensions }) => {
            const selectButton = document.querySelector('.js_pdp_dimension-selection-sheet__select-button');
            if (!selectButton) return;
            (selectButton as unknown as { disabled: boolean }).disabled = hasInvalidDimensions;
        });
    }

    private addClickListenerForAdjustDimButton() {
        const adjustDimButton = document.querySelector('.js_pdp_dimension-selection-sheet__adjust-dim-btn');
        if (!adjustDimButton) return;

        adjustDimButton.addEventListener('click', () => {
            trackEvent({ product_Configurator: 'open' });
        });
    }

    private addClickListenerForSelectButton() {
        const selectButton = document.querySelector('.js_pdp_dimension-selection-sheet__select-button');
        if (!selectButton) return;

        selectButton.addEventListener('click', () => {
            if (this.lastPublishedDimensionStateEvent) {
                const dimensionsFromEventAreIdenticalToInitial = this.lastPublishedDimensionStateEvent.dimensionStates.every(
                    dimensionStateFromEvent =>
                        this.selectedDimTypesAndValues.some(
                            selectedDimTypeAndValue =>
                                selectedDimTypeAndValue.type === dimensionStateFromEvent.type &&
                                selectedDimTypeAndValue.value === dimensionStateFromEvent.value
                        )
                );
                if (dimensionsFromEventAreIdenticalToInitial) {
                    trackEvent({ product_Configurator: 'select_initial' });
                } else {
                    trackEvent({ product_Configurator: 'select_other' });
                }
                o_global.eventQBus.emit(DIMENSION_SELECTED_TOPIC, {
                    ...this.lastPublishedDimensionStateEvent,
                    triggeredByDimensionSelectionSheet: true,
                });
            } else {
                trackEvent({ product_Configurator: 'select_initial' });
            }
            this.closeSheet();
        });
    }

    private closeSheet() {
        const sheet = this.getSelectionSheet();
        if (!sheet) return;
        (sheet as unknown as { open: boolean }).open = false;
    }

    private getSelectionSheet(): HTMLElement | null {
        return document.querySelector<HTMLElement>('oc-sheet-v1#pdp_dimension-selection-sheet');
    }

    private setOverflowHiddenSheet(): void {
        const sheetContentElement = this.getSelectionSheet()?.shadowRoot?.querySelector('.sheet__sheet');
        if (!sheetContentElement) return;
        (sheetContentElement as HTMLElement).style.overflow = 'hidden';
    }
}
